<template>
  <div>
    Edit
  </div>
</template>

<script>
export default {
  name: 'Edit'
}
</script>



// WEBPACK FOOTER //
// src/views/Edit.vue